import React from 'react';
import { UseFormRegister } from 'react-hook-form';
import { CheckboxButton } from '../../../../../../components/CheckboxButton';

interface PropTypes {
  candidateConsentEnabled: boolean;
  previewMode: boolean;
  formRegister: UseFormRegister<any>;
}

export function ApplicationFormCandidateConsent(props: PropTypes) {
  if (!props.candidateConsentEnabled) return null;

  const { onChange, onBlur, name, ref } = props.formRegister(
    'candidateConsented',
    {
      required: props.candidateConsentEnabled,
    },
  );

  return (
    <CheckboxButton
      name={name}
      onBlur={onBlur}
      checkboxRef={ref}
      label={
        'I accept and consent the use of my personal information for this and future job opportunities.'
      }
      labelSpanClasses={'fs-5'}
      disabled={props.previewMode}
      mandatory={props.candidateConsentEnabled}
      onChange={(ev: React.FormEvent<HTMLInputElement>) => {
        onChange(ev ?? null);
      }}
    />
  );
}
